import {MuWidget} from "mu-widget/lib/MuWidget";
import {UiDms} from "./UiDms";
import {UiTable} from "../components/UiTable";
import {BaseEditor} from "../BaseEditor";
import {UiBuSubjectsFilter} from "./UiBuSubjects";
import {BaseFilter} from "./BaseFilter";
import {focusFirstVisibleControl, formatDate, removeEmptyProperties, webalizeString} from "../Utils";
import {UiPager} from "../components/UiPager";
import {EntityLisResponse} from "./Types";
import * as XLSX from "xlsx";

export abstract class BaseModule extends MuWidget<UiDms, {}, {
	list: UiTable,
	pager: UiPager,
}> {
	protected filter: any = {};
	protected orderBy: { field: string, dir: "asc"|"desc" } = { dir: "desc", field: "id" };

	public setupList(listOpts: {filter: any, orderBy: any}) {
		if (listOpts.filter) this.filter = listOpts.filter;
		if (listOpts.orderBy) this.orderBy = listOpts.orderBy;
		this.loadList();
	}

	public loadItem(id: number|null) {
		const bse = this.openEditor(id);
		bse.savedPromise.then(() => {
			this.loadList();
			bse.muRemoveSelf();
			this.muParent.router.pushUpdate(null,{id: null});
		});
		UiDms.instance.router.pushUpdate(null, {id: id});
	}

	protected abstract openEditor(id: number|null): BaseEditor;

	async rCreateItem_click() {
		const bse = this.openEditor(null);
		bse?.savedPromise.then(() => this.loadList());
	}


	bReload_click() {
		this.loadList();
	}

	bFulltextSearch_click() {
		this.loadList();
	}

	bFulltextErase_click() {
		this.ui.cFulltext.value = "";
		this.loadList();
	}

	list_filter(ev: any, field: string) {
		const filter = this.openFilter(field);
		const blocks = filter.showByField(field);
		if (blocks.length) focusFirstVisibleControl(blocks[0]);
	}

	list_order(ev: any, field: string, dir: string) {
		this.setOrder(field, dir);
	}

	bFilter_click(ev: any) {
		this.openFilter(null);
	}

	setFilter(filterData: any): void
	{
		this.filter = filterData;
		const filterFields = UiBuSubjectsFilter.filtredFields(filterData);
		this.ui.filterCount.innerText = filterFields.length > 0 ? filterFields.length.toString() : "";
		this.loadList();
	}

	getFilter(): any
	{
		return this.filter;
	}

	private setOrder(field: string, dir: "asc"|"desc") {
		this.orderBy.field = field;
		this.orderBy.dir = dir;
		this.loadList();
	}

	protected abstract openFilter(field: string|null): BaseFilter;

	public async loadList(forExport: boolean = false) {
		/* this.muParent?.router.pushUpdate(null, {
			[this.muMetaData?.id + '_list']: JSON.stringify({
				filter: removeEmptyProperties(this.filter),
				orderBy: this.orderBy
			})
		}); */
		const filterFields = UiBuSubjectsFilter.filtredFields(this.filter);
		for(const ci of this.muNamedWidget.list.columns) {
			ci.isFiltered = filterFields.includes(ci.field);
			ci.isOrdered = this.orderBy.field === ci.field ? this.orderBy.dir : null;
		}
		const res = await this.getListData(forExport)
		this.muNamedWidget.list.data = res.list;
		this.muNamedWidget.pager?.setItemCount(res.fullCount);
		this.muNamedWidget.list.render(!forExport);
	}

	afterIndex() {
		setTimeout(() => this.loadList(), 10);
	}

	protected abstract getListData(forExport: boolean): Promise<EntityLisResponse>;

	pager_changePage() {
		this.loadList();
	}

	bExport_click() {
		this.exportList();
	}

	bFilterErase_click() {
		this.ui.cFulltext.value = "";
		this.setFilter({});
		this.loadList();
	}

	public async exportList() {
		await this.loadList(true);
		const wb = XLSX.utils.table_to_book(this.ui.list, { sheet: "sheet1" });

		// XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'base64' });
		XLSX.writeFile(
			wb,
			webalizeString(this.ui.label.innerText + " " + formatDate("Y-m-d H:i", new Date()))
				+ ".xlsx",
			{ compression: true }
		);
		await this.loadList(false);
	}
}